<template>
    <div>
        <v-row>
            <v-col>
                <v-alert
                    dense
                    outlined
                    type="success"
                    color="teal darken-4"
                    elevation="2"
                >
                    This approval number has been verified! Your facility has confirmed the receipt and usage of this ACU approval.
                </v-alert>
            </v-col>
        </v-row>
        <v-row class="mb-2" style="background-color: #eeeff0; padding: 10px; border-radius: 6px;">
            <v-col cols="12" md="6">
                <strong>Name:</strong> {{ items.all[0] && items.all[0].LAST_M }}
            </v-col>
            <v-col cols="12" md="6">
                <strong>Approval Number:</strong> {{ items.all[0] && items.all[0].OPAN_N }}
            </v-col>
            <v-col cols="12" md="6">
                <strong>Member Number:</strong> {{ items.all[0] && items.all[0].MEMB_N }}
            </v-col>
            <v-col cols="12" md="6">
                <strong>Validity:</strong> {{ formatDate2(items.all[0] && items.all[0].APPR_D) }} &nbsp;to&nbsp; {{ formatDate2(items.all[0] && items.all[0].VALI_D) }}
            </v-col>
            <v-col cols="12" md="6">
                <strong>Birthday:</strong> {{ formatDate2(items.all[0] && items.all[0].BIRT_D) }}
            </v-col>
            <v-col cols="12" md="6">
                <strong>Age:</strong> {{ items.all[0] && items.all[0].AGE }}
            </v-col>
            <v-col cols="12" md="6">
                <strong>Account Name:</strong> {{ items.all[0] && items.all[0].ACCT_M }}
            </v-col>
            <v-col cols="12" md="6">
                <strong>Gender:</strong> {{ items.all[0] && items.all[0].SEX }}
            </v-col>
        </v-row>
        <v-divider />
        <div style="position: relative; height: 40px; padding-top: 5px; margin: 10px 0">
            <p
                v-if="isItemsToEditEverySelected"
                style="margin-top: 3px; font-weight: 600; letter-spacing: 1px;"
            >
                All procedures are done ({{ numberOfDoneProcedure }}/{{ numberOfAllProcedure }}) <v-icon color="green">
                    {{ mdiCheckboxMarked }}
                </v-icon>
            </p>
            <p
                v-else
                style="margin-top: 3px; font-weight: 600; letter-spacing: 1px;"
            >
                {{ numberOfDoneProcedure }}/{{ numberOfAllProcedure }} Completed - {{ numberOfPendingProcedure }} Pending <v-icon color="orange">
                    {{ mdiTimerSand }}
                </v-icon>
            </p>
            <v-spacer />
            <v-btn
                v-show="!isItemsToEditEverySelected"
                :disabled="isItemsToEditEverySelected"
                :loading="loading"
                style="position: absolute; right: 0; top: 0;"
                color="teal"
                class="white--text"
                @click="$emit('handleEditAcu')"
            >
                <v-icon small left>
                    {{ mdiPencil }}
                </v-icon>mark as done
            </v-btn>
        </div>
        <v-divider />
    </div>
</template>

<script>
import { mdiCheckboxMarked, mdiPencil, mdiTimerSand } from '@mdi/js'
import { moment } from '../../../../utils/date-shim'
export default {
    props: ['items', 'loading'],
    data: () => ({
        mdiCheckboxMarked, mdiPencil, mdiTimerSand
    }),
    computed: {
        numberOfPendingProcedure() {
            return this.items.all.filter(item => item.value === false).length
        },
        numberOfAllProcedure() {
            return this.items.all.length
        },
        numberOfDoneProcedure() {
            return this.items.all.filter(item => item.value === true).length
        },
        isItemsToEditEverySelected() {
            return this.items.all.every(item => item.value === true)
        }
    },
    methods: {
        formatDate2(date) {
            return moment(date).utcOffset('+0800').startOf('day').format('MMMM D, YYYY')
        }
    }
}
</script>
